import setInboxAndSweepRulesService from '../services/setInboxAndSweepRulesService';
import { InboxRulesListOptionState } from '../store/schema/InboxRulesListOptionState';
import store from '../store/store';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { select } from 'satcheljs/lib/legacy';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import datapoints from '../datapoints';

export interface SetInboxRulesOptionState {
    optionState: InboxRulesListOptionState;
}
/**
 * Saves the current inbox rule configuration
 */
export default select<SetInboxRulesOptionState>({
    optionState: () => store.inboxRulesListState,
})(
    createLegacyActionWithDatapoint('setInboxRules', datapoints.setInboxRulesDatapoint)(
        function setInboxRules(state?: SetInboxRulesOptionState) {
            let datapoint = returnTopExecutingActionDatapoint();
            let { optionState } = state;
            let inboxRuleIds = optionState.inboxRuleIds;
            let inboxRuleMap = optionState.inboxRules;

            return setInboxAndSweepRulesService(inboxRuleIds, inboxRuleMap)
                .then(response => {
                    if (!response.WasSuccessful) {
                        let errorMessage = response.ErrorMessage
                            ? response.ErrorMessage
                            : 'Response WasSuccessful was false';
                        datapoint.endWithError(
                            DatapointStatus.ServerError,
                            new Error(errorMessage)
                        );
                    }
                })
                .catch(error => {
                    datapoint.endWithError(DatapointStatus.ServerError, error.message);
                });
        }
    )
);
